import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { B2cAssessmentComponent } from './b2c-assessment/b2c-assessment.component';
import { ResetLinkConfirmationComponent } from './reset-link-confirmation/reset-link-confirmation.component';
import { OktaAuthGuard } from '@okta/okta-angular';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { OktaLoginComponent } from './okta-login/okta-login.component';

const routes: Routes = [
  {
    path: '', 
    component: LoginComponent
  },
  {
    path: 'login', 
    component: LoginComponent,
  },
  {
    path: 'forgot-password', 
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token', 
    component: ResetPasswordComponent,
  },
  {
    path: 'individual-assessment',
    component: B2cAssessmentComponent,
  },
  {
    path: 'reset-link-confirmation',
    component: ResetLinkConfirmationComponent,
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'okta',
    component: OktaLoginComponent,
    canActivate: [ OktaAuthGuard ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
